import {
  SET_WRAPPER_CLASS,
  SET_ACTIVE_STEP,
  SET_INPUT_TERM,
  SET_ACTIVE_TAB,
  SET_SUGGESTIONS,
  SET_INITIAL_CATEGORIES,
  CLEAN_CATEGORIES,
  SET_CATEGORIES_LEVEL,
  UPDATE_SELECTED_CATEGORY,
  SET_SEARCH,
  UNSET_SEARCH,
  SET_PRODUCTS_LOADING,
  UNSET_PRODUCTS_LOADING,
  SET_PRODUCTS,
  SET_USER_DETAILS,
  SET_SELECTED_PRODUCT,
  SET_PRODUCT_REG_GUID,
  SET_IS_CONFIRMATION,
  SET_HAS_MARKETING_CONSENT,
} from '@/product-registration/context/types';

export const setWrapperClass = payload => ({
  type: SET_WRAPPER_CLASS,
  payload,
});
export const setActiveStep = payload => ({ type: SET_ACTIVE_STEP, payload });
export const setInputTerm = payload => ({ type: SET_INPUT_TERM, payload });
export const setActiveTab = payload => ({ type: SET_ACTIVE_TAB, payload });
export const setSuggestions = payload => ({ type: SET_SUGGESTIONS, payload });
export const setInitialCategories = payload => ({
  type: SET_INITIAL_CATEGORIES,
  payload,
});
export const cleanCategories = payload => ({ type: CLEAN_CATEGORIES, payload });
export const updateSelectedCategory = payload => ({
  type: UPDATE_SELECTED_CATEGORY,
  payload,
});
export const setCategoriesLevel = payload => ({
  type: SET_CATEGORIES_LEVEL,
  payload,
});
export const setSearch = payload => ({
  type: SET_SEARCH,
  payload,
});
export const unsetSearch = () => ({ type: UNSET_SEARCH });
export const setProductsLoading = () => ({ type: SET_PRODUCTS_LOADING });
export const unsetProductsLoading = () => ({ type: UNSET_PRODUCTS_LOADING });
export const setProducts = payload => ({
  type: SET_PRODUCTS,
  payload,
});
export const setUserDetails = payload => ({
  type: SET_USER_DETAILS,
  payload,
});
export const setSelectedProduct = payload => ({
  type: SET_SELECTED_PRODUCT,
  payload,
});
export const setproductRegGuid = payload => ({
  type: SET_PRODUCT_REG_GUID,
  payload,
});
export const setIsConfirmation = payload => ({
  type: SET_IS_CONFIRMATION,
  payload,
});
export const setHasMarketingConsent = payload => ({
  type: SET_HAS_MARKETING_CONSENT,
  payload,
});
